import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 1, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <motion.span
        className={`block overflow-hidden ${className}`}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-40px" }}
    >
        <motion.span
            className="block will-change-transform"
            variants={{ hidden: { y: "115%" }, visible: { y: 0 } }}
            transition={{ duration: 1.15, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </motion.span>
);

export const SectionNumber = ({ n, label, dark = false }) => (
    <div className="mb-10 flex items-center gap-5">
        <span
            className={`font-display text-base font-light tracking-[0.3em] ${
                dark ? "text-[#C8102E]" : "text-[#C8102E]"
            }`}
        >
            {n}
        </span>
        <span className="h-px w-16 bg-gradient-to-r from-[#C8102E] to-transparent" />
        <span
            className={`text-sm uppercase tracking-[0.3em] ${
                dark ? "text-[#93A68E]" : "text-[#5C6B57]"
            }`}
        >
            {label}
        </span>
    </div>
);
